import * as Yup from 'yup';

export class UpdateDocumentValidator {
  constructor() {}

  public get schema() {
    return Yup.object().shape({
      description: Yup.string().required('Informe a descrição'),
      category: Yup.string().required('Informe a categoria')
    });
  }
}
